export const getMaxPromtions = () => ({ desktop: Infinity, mobile: Infinity });
